import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MarketSectorsPopoverComponent } from '../market-sectors-popover/market-sectors-popover.component';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-wisee',
  templateUrl: './wisee.component.html',
  styleUrls: ['./wisee.component.css'],
})
export class WiseeComponent implements OnInit {
  @Input() marketSectors: any[] = [];
  toolTip = '';

  constructor(private popoverController: PopoverController) {}

  ngOnInit(): void {
    this.toolTip = this.marketSectors
      ?.map((e) => e.name)
      .slice(0, 5)
      .join(', ');
  }

  async click(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const popover = await this.popoverController.create({
      component: MarketSectorsPopoverComponent, // A component that will show market sector names
      componentProps: {
        marketSectors: this.marketSectors,
      },
      event: event,
      translucent: true,
      showBackdrop: false,
      backdropDismiss: true,
      animated: true,
      size: 'auto',
      side: 'start', // Automatically positions the popover above the element if possible
      cssClass: 'max-h-300 overflow-y-auto', // Tailwind classes to make the popover scrollable
    });

    environment.log(this.marketSectors);

    await popover.present();
  }
}
